import { render, staticRenderFns } from "./CatalogRecommendedTag.vue?vue&type=template&id=47f0ac25&"
import script from "./CatalogRecommendedTag.vue?vue&type=script&lang=ts&"
export * from "./CatalogRecommendedTag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports